import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FocusSection from "./components/FocusSection";
import Channels from "./components/Channels";
import Roundup from "./components/Roundup";
import Forum from "./components/Forum";
import Ranking from "./components/Ranking";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition hover:bg-primary-600 ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </button>
  );
}

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "吃瓜聚集地是一个什么样的社区？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "吃瓜聚集地是一个面向全网热点与圈层话题的讨论社区，汇集娱乐、互联网、社会、数码等多个圈层的最新事件，支持群组讨论与观点交流。",
      },
    },
    {
      "@type": "Question",
      name: "如何订阅每天的热点汇总？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "在页面底部填写邮箱并订阅吃瓜日报，我们会每天整理当日讨论度最高的若干话题发送到邮箱，免费订阅、随时可退订。",
      },
    },
    {
      "@type": "Question",
      name: "看到的内容可靠吗，会不会吃到假瓜？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "我们鼓励内容标注来源与时间线，倡导网友理性围观、不传谣不造谣，事件以官方或当事人公开说法为准。",
      },
    },
  ],
};

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <Header />
      <main>
        <Hero />
        <FocusSection />
        <Channels />
        <Roundup />
        <Forum />
        <Ranking />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}